import React from "react";
import { connect } from "react-redux";
import AppBar from "material-ui/AppBar";
import { withRouter } from "react-router-dom";
import Toolbar from "material-ui/Toolbar";
import IconButton from "material-ui/IconButton";
import { Dropdown, DropdownMenu, DropdownToggle } from "reactstrap";
import {
  COLLAPSED_DRAWER,
  DARK_THEME,
  FIXED_DRAWER,
  THEME_COLOR,
} from "constants/ActionTypes";
import SearchBox from "components/SearchBox";
import AppNotification from "../AppNotification/index";
import CardHeader from "components/dashboard/Common/CardHeader/index";
import { switchLanguage } from "actions/Setting";
import IntlMessages from "util/IntlMessages";
import SweetAlert from "react-bootstrap-sweetalert";
// import LanguageSwitcher from 'components/LanguageSwitcher/index';
import { searchDevices, getThresholdData } from "util/aws-manager";

import SearchModal from "./SearchModal";

import * as CONST from "../../util/app-constants";
import { highlightNavigatedMenu } from "util/highlightSidebarOption";

class Header extends React.Component {
  currentPath;
  // mqttClient;
  searchPageNumber = 1;
  getAllNotificationPageNumber = 1;
  onAppNotificationSelect = () => {
    this.setState({
      appNotification: !this.state.appNotification,
    });
  };
  onLangSwitcherSelect = (event) => {
    this.setState({
      langSwitcher: !this.state.langSwitcher,
      anchorEl: event.currentTarget,
    });
  };
  onSearchBoxSelect = () => {
    this.setState({
      searchBox: !this.state.searchBox,
    });
  };
  handleRequestClose = () => {
    this.setState({
      langSwitcher: false,
      mailNotification: false,
      appNotification: false,
      searchBox: false,
    });
  };

  constructor() {
    super();
    this.state = {
      anchorEl: undefined,
      searchBox: false,
      searchText: "",
      mailNotification: false,
      langSwitcher: false,
      appNotification: false,
      searchModal: "",
      linkOfLogo: "",
      linkToLogo: "./assets/images/Senstra_logo-2.png",
      notificationTopic: "symbiotic/notification",
      activeNotifications: [],
      activeResults: "",
      closeNotification: false,
    };

    this.onButtonClick.bind(this);
    this.updateStoreAndRedirectToHeartbeatPage.bind(this);
  }

  componentDidMount() {
    // getThresholdData(this.props.deviceId).then((data) => {
    //   this.props.updateThresholds(data.Items);
    // });

    this.currentPath = this.props.location.pathname;

    if (this.props.profileInfo.themeToApply !== null) {
      if (this.props.profileInfo.themeToApply === "dark-theme") {
        this.props.setDarkTheme();
        const body = $("#body");
        body.removeClass();
        body.addClass("dark-theme");
      } else {
        this.props.setThemeColor(this.props.profileInfo.themeToApply);
        const body = $("#body");
        body.removeClass("dark-theme");
        body.removeClass();
        body.addClass(this.props.profileInfo.themeToApply);
      }
    }

    // this.initialiseMQTT();

    $("#bell-icon").on("click", () => this.removeWobbleAndBadge());
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.deviceId !== nextProps.deviceId) {
      // getThresholdData(nextProps.deviceId).then((data) => {
      //   this.props.updateThresholds(data.Items);
      // });
    }

    if (
      nextProps.linkOfLogo &&
      nextProps.linkOfLogo !== this.state.linkOfLogo
    ) {
      this.setState({
        linkOfLogo: nextProps.linkOfLogo,
      });
    }

    if (
      nextProps.linkToLogo &&
      nextProps.linkToLogo !== this.state.linkToLogo
    ) {
      this.setState({
        linkToLogo: nextProps.linkToLogo,
      });
    }

    if (
      this.props.notificationDeviceId !== nextProps.notificationDeviceId ||
      this.props.notificationTimestamp !== nextProps.notificationTimestamp
    ) {
      this.removeNotificationFromList(
        nextProps.notificationDeviceId,
        nextProps.notificationTimestamp
      );
    }
  }

  saveDeviceIdAndTimestampToStoreAndNavigateToNotificationsPage = (
    deviceId,
    timestamp
  ) => {
    highlightNavigatedMenu("notifications", `#${this.currentPath}`);
    this.props.history.push("/app/components/notifications");
    this.props.updateDeviceIdAndSetTimestamp(deviceId, timestamp); // TODO: find out better way to pass props
  };

  updateSearchText(evt) {
    this.setState({
      searchText: evt.target.value,
    });
  }

  clearSearchText = () => {
    this.setState({
      searchText: "",
    });
  };

  unique = (value, index, self) => {
    return self.indexOf(value) === index;
  };

  onButtonClick = () => {
    this.setState({
      searchModal: "",
    });

    if (this.state.searchText) {
      searchDevices(this.state.searchText, this.searchPageNumber).then(
        (data) => {
          if (data.length != 1) {
            const uniqueSearchResults = data.filter(this.unique);
            this.setState({
              searchModal: (
                <SearchModal
                  clearSearchText={this.clearSearchText}
                  data={uniqueSearchResults}
                  defaultText={this.state.searchText}
                  onViewPitClick={this.updateStoreAndRedirectToHeartbeatPage}
                />
              ),
            });

            $("#searchModal").modal();
          } else {
            this.setState({
              searchText: ''
            })
            this.updateStoreAndRedirectToHeartbeatPage(data[0]);
          }

        },
        () => { }
      );
    }
  };

  updateStoreAndRedirectToHeartbeatPage = (deviceId) => {
    this.props.updateDeviceId(deviceId);
    $("#searchModal").modal("hide");
    if (
      !(
        this.currentPath === "/app/components/heartbeat" ||
        this.currentPath === "/app/components/notifications"
      )
    ) {
      highlightNavigatedMenu("heartbeat", `#${this.currentPath}`);
      this.props.history.push("/app/components/heartbeat");
    }
    this.setState({
      searchModal: false,
    });
  };

  componentWillMount() {
    this.unlisten = this.props.history.listen((location) => {
      this.currentPath = location.pathname;
    });
  }

  componentWillUnmount() {
    this.unlisten();
    // this.disconnectMQTT();
  }

  handleKeyPress = (e) => {
    if (e.key === "Enter") {
      this.onButtonClick();
    }
  };

  // initialiseMQTT() {
  //     let header = this;
  //     mqttClientConnect();
  //     header.mqttClient = getMqttClient();
  //     header.registerCallbacks();
  //     authenticate().then(() => {
  //         console.log("## authenticated");
  //         return getNotifications("AllActive", this.getAllNotificationPageNumber, null);
  //     }).then((data) => {
  //         if(data.Items)
  //         {
  //             header.setState({ activeNotifications: data.Items });
  //         }
  //         if (header.state.activeNotifications.length === 0) {
  //             this.setState({
  //                 activeResults: 'No Notifications to display',
  //             });
  //             header.removeWobbleAndBadge();
  //         } else {
  //             this.setState({
  //                 activeResults: '',
  //             });
  //             header.addWobbleAndBadge();
  //         }
  //     }).catch((err) => {
  //         console.error(err);
  //     });
  // }

  removeNotificationFromList(deviceID, timestamp) {
    let currentNotifications = [...this.state.activeNotifications]; // make a separate copy of the array
    currentNotifications = currentNotifications.filter(function (notification) {
      return (
        notification &&
        !(
          notification.deviceID === deviceID &&
          notification.notificationTimestamp === timestamp
        )
      );
    });
    this.setState({ activeNotifications: currentNotifications });
  }

  // registerCallbacks = () => {
  //     let header = this;
  //     header.mqttClient.on('connect', () => {
  //         console.log("### connected, subscribing to ", header.state.notificationTopic);
  //         // Subscribe to our current topic.
  //         header.mqttClient.subscribe(header.state.notificationTopic);
  //     });

  //     header.mqttClient.on('message', (topic, payload) => {
  //         try {
  //             console.log("### message", topic);
  //             switch (topic) {
  //                 case header.state.notificationTopic:
  //                     header.addWobbleAndBadge();
  //                     this.setState({
  //                         activeNotifications: [JSON.parse(payload), ...this.state.activeNotifications]
  //                     });
  //                     break;
  //                 default:
  //                     header.props.sendDevicePayload(payload);
  //             }
  //         } catch (e) {
  //             // NOTE: in case of error, we don't want onMessage callback to stop working. Hence catching the error and just logging.
  //             console.error("### Error onMessage ", e);
  //         }
  //     });

  //     header.mqttClient.on('offline', () => {
  //         console.log("### offline");
  //     });

  //     header.mqttClient.on('close', () => {
  //         console.log("### close");
  //     });

  //     header.mqttClient.on('reconnect', () => {
  //         console.log("### reconnect")
  //     });

  //     header.mqttClient.on('error', (e) => {
  //         // console.error("### Error Connecting MQTT Client.", e ? e.toString() : '')
  //     });
  // };

  // disconnectMQTT() {
  //     console.log("### Unsubscribing from ", this.state.notificationTopic);
  //     this.mqttClient.unsubscribe(this.state.notificationTopic);
  //     this.mqttClient.end();
  // }

  removeWobbleAndBadge = () => {
    $("#bell-icon").removeClass("icon-alert animated infinite wobble");
  };

  addWobbleAndBadge = () => {
    $("#bell-icon").addClass("icon-alert animated infinite wobble");
  };

  clearNotification = () => {
    this.setState({
      activeNotifications: [],
      closeNotification: false,
      activeResults: "No Notifications to display",
    });
  };

  onCancelClick = () => {
    this.setState({
      closeNotification: false,
    });
  };

  handleClearNotification = () => {
    this.setState({
      closeNotification: true,
    });
  };

  render() {
    const { onToggleCollapsedNav, drawerType } = this.props;
    const drawerStyle = drawerType.includes(FIXED_DRAWER)
      ? "d-block d-xl-none"
      : drawerType.includes(COLLAPSED_DRAWER)
        ? "d-block"
        : "d-none";

    return (
      <AppBar className="app-main-header">
        <Toolbar className="app-toolbar" disableGutters={false}>
          <SweetAlert
            show={this.state.closeNotification}
            style={{ color: "black" }}
            showCancel
            confirmBtnBsStyle="primary"
            cancelBtnBsStyle="primary"
            title={`All notifications have been cleared`}
            cancelBtnText="Cancel"
            confirmBtnText="OK"
            onCancel={this.onCancelClick}
            onConfirm={this.clearNotification}
          >
            Click cancel if you don't want to clear all Notifications.
          </SweetAlert>
          <IconButton
            className={`jr-menu-icon ${drawerStyle}`}
            aria-label="Menu"
            onClick={onToggleCollapsedNav}
          >
            <span className="menu-icon text-black" />
          </IconButton>

          <a className="app-logo" href={this.state.linkOfLogo} target="_blank">
            <img
              src={this.state.linkToLogo}
              onError={(e) => {
                e.target.src = CONST.DEFAULT_LOGO_IMG;
              }}
            />
          </a>

          <SearchBox
            styleName="d-none d-sm-block"
            placeholder="Search by Device ID"
            onChange={this.updateSearchText.bind(this)}
            value={this.state.searchText}
            onKeyPress={this.handleKeyPress.bind(this)}
            onButtonClick={this.onButtonClick}
          />

          {this.state.searchModal}

          <ul className="header-notifications list-inline ml-auto">
            <li className="d-inline-block d-sm-none list-inline-item">
              <Dropdown
                className="quick-menu nav-searchbox"
                isOpen={this.state.searchBox}
                toggle={this.onSearchBoxSelect.bind(this)}
              >
                <DropdownToggle
                  className="d-inline-block"
                  tag="span"
                  data-toggle="dropdown"
                >
                  <IconButton className="icon-btn size-30">
                    <i className="icon-color-search zmdi zmdi-search zmdi-hc-fw" />
                  </IconButton>
                </DropdownToggle>

                <DropdownMenu right className="p-0">
                  <SearchBox
                    styleName="search-dropdown"
                    placeholder=""
                    onChange={this.updateSearchText.bind(this)}
                    value={this.state.searchText}
                    onKeyPress={this.handleKeyPress.bind(this)}
                    onButtonClick={this.onButtonClick}
                  />
                </DropdownMenu>
              </Dropdown>
            </li>
            <li className="list-inline-item">
              <Dropdown
                className="quick-menu"
                isOpen={this.state.langSwitcher}
                toggle={this.onLangSwitcherSelect.bind(this)}
              ></Dropdown>
            </li>
            <li className="list-inline-item app-tour">
              <div className="dropdown quick-menu">
                {/* <IconButton className="icon-btn size-30" data-toggle="dropdown">
                                    <i id="bell-icon" className="zmdi zmdi-notifications-active" />
                                </IconButton> */}

                <div className="dropdown-menu pr-1 pl-1">
                  <CardHeader
                    styleName="align-items-center"
                    heading={<IntlMessages id="appNotification.title" />}
                  />
                  <AppNotification
                    notifications={this.state.activeNotifications}
                    onNotificationClick={(deviceID, timestamp) => {
                      this.saveDeviceIdAndTimestampToStoreAndNavigateToNotificationsPage(
                        deviceID,
                        timestamp
                      );
                    }}
                  />
                  {this.state.activeNotifications.length ? (
                    <div className="clear-Button">
                      <a onClick={this.handleClearNotification}>
                        Clear All Notifications
                      </a>
                    </div>
                  ) : (
                      <div className="active-results">
                        <a>{this.state.activeResults}</a>
                      </div>
                    )}
                </div>
              </div>

              <Dropdown
                className="quick-menu"
                isOpen={this.state.appNotification}
                toggle={() => {
                  this.props.signOut();
                  window.open("https://senstra.com.au/platform");
                }}
              >
                {/* <DropdownToggle
                  className="d-inline-block"
                  tag="span"
                  data-toggle="dropdown"
                >
                  <IconButton
                    style={{
                      color: "black",
                      fontSize: 15,
                    }}
                  >
                    Logout
                  </IconButton>
                  <IconButton className="size-30">
                    <i className="zmdi zmdi-sign-in" />
                  </IconButton>
                </DropdownToggle> */}

                {/* <DropdownMenu right className="pr-1 pl-1">
                                    <CardHeader
                                        styleName="align-items-center"
                                        heading={<IntlMessages id="appNotification.title"/>}
                                    />
                                    <AppNotification notifications={this.state.activeNotifications} onNotificationClick={(deviceID, timestamp) => {
                                        this.saveDeviceIdAndTimestampToStoreAndNavigateToNotificationsPage(deviceID, timestamp)
                                    }}/>
                                </DropdownMenu> */}
              </Dropdown>
            </li>
          </ul>
        </Toolbar>
      </AppBar>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    signOut: () => {
      dispatch({ type: "SIGN_OUT" });
    },
    updateDeviceId: (id) => {
      dispatch({ type: "UPDATE_DEVICE_ID", deviceId: id });
    },
    updateDeviceIdAndSetTimestamp: (deviceId, timestamp) => {
      dispatch({
        type: "UPDATE_DEVICE_ID_AND_TIMESTAMP",
        deviceId: deviceId,
        notificationPageTimestampOfElementToHighlight: timestamp,
      });
    },
    updateThresholds: (data) => {
      if (data && data[0]) {
        dispatch({ type: "UPDATE_THRESHOLDS", data });
      }
    },
    switchLanguage,
    setThemeColor: (color) => {
      dispatch({ type: THEME_COLOR, color });
    },
    setDarkTheme: () => {
      dispatch({ type: DARK_THEME });
    },
    sendDevicePayload: (payload) => {
      dispatch({ type: "DEVICE_PAYLOAD", payload: payload });
    },
  };
};

const mapStateToProps = ({ settings, symbioticReducer, profileInfo }) => {
  const { locale } = settings;
  return {
    locale,
    deviceId: symbioticReducer.deviceId,
    profileInfo,
    linkOfLogo: symbioticReducer.linkOfLogo,
    linkToLogo: symbioticReducer.linkToLogo,
    notificationDeviceId: symbioticReducer.notificationDeviceId,
    notificationTimestamp: symbioticReducer.notificationTimestamp,
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));



// WEBPACK FOOTER //
// ./components/Header/index.js